import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlacardEditionRequest } from '../api/models/placardEdit';
import { ApiErrorCode, ServiceURLConstants } from '../constants/upplm.constants';
import { UpsCommonService } from './upplm.common.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};


@Injectable()

export class PlacardEditionService {

  private url: string = '';

  constructor(private httpclient: HttpClient,
    private _commonService: UpsCommonService,) { }

  async editPlacard(placardId: string, request: PlacardEditionRequest) {
      this.url = this._commonService.createURL(`${ServiceURLConstants.EDIT_PLACARD}/${placardId}`, ApiErrorCode.EDIT_PLACARD);
    return await this.httpclient.post<any>(this.url, JSON.stringify(request), httpOptions).toPromise();
  }
}